/** @format */
import getNextConfig from 'next/config';

// eslint-disable-next-line boundaries/element-types, boundaries/entry-point -- Touch and change -- We shouldn't import from client into common
import { PublicRuntimeConfig } from '@toucan/client/global/nextjs/config/types';

/** @format */

export type WindowWithToucanConfig = Window & {
    __TOUCAN_RUNTIME_CONFIG__?: any;
};

type Config = { publicRuntimeConfig: PublicRuntimeConfig };

export function getConfig(): Config {
    const isServer = typeof window === 'undefined';
    const { publicRuntimeConfig } = getNextConfig() || {};

    if (isServer) {
        return { publicRuntimeConfig };
    }

    const clientConfig =
        (window as WindowWithToucanConfig)?.__TOUCAN_RUNTIME_CONFIG__ ?? {};

    return {
        publicRuntimeConfig: {
            ...publicRuntimeConfig,
            ...clientConfig,
        },
    };
}
